const imgURL = `${process.env.REACT_APP_CLOUDFRONT_URL}/accounts/credits`;

export const creditsData = {
  Foos: {
    img: `${imgURL}/GracieWozNaomi.png`,
    title: 'Foos',
    rows: [
      {
        'characters': 'Gracie/Safari Sam/Malwaria/Gerty/Nugget',
        'actor': 'Sandra Diana Cantú',
      },
      {
        'characters': 'Val/Amelia',
        'actor': 'Tatiana Cantú',
      },
      {
        'characters': 'Professor Looney Bubbles',
        'actor': 'Natalie Figaredo',
      },
      {
        'characters': 'Monkey King',
        'actor': 'Levi Gotsman',
      },
      {
        'characters': 'Sarge/MegaHertz/Gramps',
        'actor': 'Chris M. Kauffmann',
      },
      {
        'characters': 'Sergio/Ethan',
        'actor': 'Nik Nieblas',
      },
      {
        'characters': 'Woz/Dali',
        'actor': 'Tyler Scott Null',
      },
      {
        'characters': 'Calamity/Ka-Pow',
        'actor': 'Kathryn Powell',
      },
      {
        'characters': 'Naomi/Queen Candy/Savannah/Marina/Trojan/Hachi',
        'actor': 'Elisa R. Richter',
      },
      {
        'characters': 'Foodini/Ichi/Pigsy/Darryl/The Glitch/Trigger',
        'actor': 'Seth Thygesen',
      },
      {
        'characters': 'Additional Voices',
        'actor': 'Moonwalk Audio',
      },
    ],
  },
  Scrapimals: {
    img: `${imgURL}/Zuzu Penn Ringo.png`,
    title: 'Scrapimals',
    rows: [
      {
        'characters': 'Pat/Kit/The Kid',
        'actor': 'Stacy Allen',
      },
      {
        'characters': 'Katrina/Madame Mystique',
        'actor': 'Ashley Nguyen DeWitt',
      },
      {
        'characters': 'Zuzu/Ringo',
        'actor': 'Nik Nieblas',
      },
      {
        'characters': 'Penn/Ern',
        'actor': 'Jason Marnocha',
      },
      {
        'characters': 'Additional Voices',
        'actor': 'Moonwalk Audio',
      },
    ],
  },
  bottomImg: {
    img: `${imgURL}/Glitch_jetpack.png`,
    title: '',
    rows: [],
  },
};



// WEBPACK FOOTER //
// ./src/containers/Credits/creditsData.js